module.exports = __webpack_public_path__ + "static/media/icon_dayNormal.771534bc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_dayNormal.svg
// module id = 2415
// module chunks = 7